export function formatPropertyPrice(price, currencyCode = "COP") {
  if (price === null || price === undefined) {
    return "—";
  }

  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits: 0,
    }).format(price);
  } catch {
    return `${price} ${currencyCode}`;
  }
}

export function formatPropertyLabel(value) {
  if (!value) {
    return "—";
  }

  return String(value).replace(/_/g, " ");
}

export function formatAreaSqM(value) {
  if (value === null || value === undefined) {
    return null;
  }

  const rounded = Math.round(value);
  return `${rounded} m²`;
}

/** Compact price label for narrow context-panel sliders (e.g. $300M, $1.2B). */
export function formatCompactPropertyPrice(price, currencyCode = "COP") {
  if (price === null || price === undefined) {
    return "—";
  }

  const abs = Math.abs(price);
  if (abs >= 1_000_000_000) {
    const billions = price / 1_000_000_000;
    const text = billions >= 10 ? `${Math.round(billions)}` : billions.toFixed(1).replace(/\.0$/, "");
    return `$${text}B`;
  }

  if (abs >= 1_000_000) {
    return `$${Math.round(price / 1_000_000)}M`;
  }

  if (abs >= 1_000) {
    return `$${Math.round(price / 1_000)}K`;
  }

  return formatPropertyPrice(price, currencyCode);
}

export function formatCompactPriceRange(min, max, currencyCode = "COP") {
  if (min == null && max == null) {
    return "—";
  }

  const suffix = currencyCode && currencyCode !== "USD" ? ` ${currencyCode}` : "";
  return `${formatCompactPropertyPrice(min, currencyCode)} — ${formatCompactPropertyPrice(
    max,
    currencyCode
  )}${suffix}`;
}

export function formatAreaRangeLabel(min, max) {
  if (min == null || max == null) {
    return "—";
  }

  return `${Math.round(min)} m² — ${Math.round(max)} m²`;
}
